import { useSelector } from 'react-redux';
import useQueryParams from '../../hooks/useQueryParams';
import { RootState } from '../../types';
import HomeRoute from '../Helmet/HomeRoute';
import RedirectRoute from './RedirectRoute';

interface GuestRouteProps {
  children: React.ReactNode;
  pageTitle?: string;
}

interface Query {
  redirectTo?: string;
}

const GuestRoute: React.FC<GuestRouteProps> = ({ children, pageTitle }) => {
  const { redirectTo } = useQueryParams<Query>();
  const { authUserDetail } = useSelector((state: RootState) => state.auth);

  if (authUserDetail) {
    return <RedirectRoute to={redirectTo ? redirectTo : '/'} />;
  }

  return <HomeRoute title={pageTitle}>{children}</HomeRoute>;
};

export default GuestRoute;
